import React from 'react';

import { Text, Box } from 'components';

const Support = props => {
  return (
    <Box className="mr-md" mb="4" flex="1" p="4" shadow>
      <Box className="d-lg-flex position-relative">
        <img
          alt="customer support team"
          className="mr-3"
          src={require('../../images/cs.svg')}
          width={72}
          height={45}
        />
        <Box>
          <Text display="h4">Current Support Team</Text>
          <Text display="h5">Josh - Caleb – Judd</Text>
        </Box>
        <Box className="cs-contact" ml="auto">
          <a href="mailto:ops@current.us">
            <img
              alt="contact us"
              src={require('../../images/cs-contact.svg')}
              width={31}
              height={32}
            />
          </a>
        </Box>
      </Box>
      <Text py="3">
        We’re here to answer any questions you might have regarding your
        purchase. We strive to keep information in our FAQ up-to-date.
      </Text>
    </Box>
  );
};

export default Support;
